// Facebook配置
export const FACEBOOK_CONFIG = {
  // 请替换为您的Facebook App ID
  APP_ID: '4080156462249257',
  
  // Facebook SDK版本 - 使用最新版本 v24.0
  VERSION: 'v24.0',
  
  // 权限范围
  SCOPE: 'email,public_profile',
  
  // 返回的权限
  RETURN_SCOPES: true
};

// Facebook API字段
export const FACEBOOK_FIELDS = 'id,name,email,picture';
